module.exports = __webpack_public_path__ + "img/expand.1cb56617.svg";